/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import courseraPlus from 'bundles/epic/data/defaults/courseraPlus.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  welcome: 'control' | 'features' | 'carousel';
  isCollectionPagePendoEnabled: boolean;
  checkoutSubscriberCountAndPartnerLogo: 'control' | '1' | '2' | '3';
  isLearnerImpressedInIndiaTiersEpic: boolean;
  s12nToCourseraPlusEmailFlowEnabled: boolean;
  enableFreemiumPricing: boolean;
  upsellCopyUpdates: 'optOut' | 'variant1';
  cplus_q4_nov_global_tentpole_promo_redirect: boolean;
  isLandingPagePromoEnabled: boolean;
  showHeroPriceOverlay: boolean;
  promoCodeForLandingPage: 'seize-the-savings-2026-global' | 'seize-the-savings-2026-updated';
  newYear2026PromoCodeForUSAOnly: 'new-year-2026-global';
  postCourseCompletionUpsell: 'control' | 'variant1' | 'variant2';
  collectionsRolloutEnabled: boolean;
  promoLandingPageSlug: 'coursera-plus-landing-page-promo' | 'coursera-plus-landing-page-promo-extended';
};

const NAMESPACE = 'courseraPlus';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([courseraPlus as $TSFixMe]);

const courseraPlusEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default courseraPlusEpicClient;
